import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaLabelComponent} from './la-label.component';
import {LaTextModule} from '../text/la-text.module';

export {LaLabelComponent} from './la-label.component';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
    LaTextModule.forRoot()
  ],
  exports: [LaLabelComponent],
  declarations: [LaLabelComponent]
})
export class LaLabelModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaLabelModule,
      providers: []
    };
  }
}
